import styled from 'styled-components'

import { IconsQA } from 'shared/dataAttributes'
import { colors } from 'shared/lib'

type VisaCardProps = {
  size?: 'small' | ''
}

export const VisaCard = ({ size = '' }: VisaCardProps) => (
  <Wrapper $size={size}>
    <CustomSvg
      $size={size}
      data-qa={IconsQA.VisaCardIcon}
      fill="none"
      height="8"
      viewBox="0 0 25 8"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <path
          d="M9.61781 0.145858L6.4726 7.87632H4.40137L2.87808 1.75029C2.85305 1.4551 2.67823 1.19515 2.41781 1.06588C1.80822 0.763664 1.16388 0.541257 0.5 0.403914V0.179517H3.78767C4.23513 0.179383 4.61622 0.512451 4.6863 0.964905L5.50822 5.45284L7.52466 0.190737L9.61781 0.145858ZM17.6507 5.35186C17.6507 3.30985 14.911 3.19765 14.9329 2.28884C14.9329 2.00835 15.1959 1.71663 15.7548 1.63809C16.4094 1.57551 17.0684 1.69571 17.6616 1.98591L18.0014 0.347815C17.4203 0.120857 16.8041 0.00303376 16.1822 0C14.2644 0 12.8945 1.05466 12.8945 2.55812C12.8945 3.6801 13.8589 4.29719 14.5932 4.66745C15.3274 5.0377 15.6014 5.28454 15.6014 5.63235C15.6014 6.14846 14.9986 6.38408 14.4397 6.38408C13.7444 6.39834 13.0573 6.22828 12.4452 5.89041L12.0726 7.5846C12.7703 7.86601 13.5145 8.00696 14.2644 7.99974C16.3027 7.99974 17.6288 6.96751 17.6397 5.35186H17.6507ZM22.7027 7.87632H24.5L22.9329 0.145858H21.289C20.9267 0.146956 20.6013 0.373452 20.4671 0.718069L17.5521 7.87632H19.5904L19.9959 6.75433H22.4836L22.7027 7.87632ZM20.511 5.13868L21.5301 2.23275L22.1548 5.11624L20.511 5.13868ZM12.3575 0.145858L10.7575 7.87632H8.85068L10.4507 0.145858H12.3575Z"
          fill="#1A1F71"
          id="Vector"
        />
      </g>
    </CustomSvg>
  </Wrapper>
)

const CustomSvg = styled.svg<{ $size: VisaCardProps['size'] }>`
  background: ${colors.FC2_WHITE};
  height: ${({ $size }) => ($size === 'small' ? '8px' : '9px')};
  width: ${({ $size }) => ($size === 'small' ? '24px' : '27px')};
`
const Wrapper = styled.div<{ $size: VisaCardProps['size'] }>`
  align-items: center;
  background: ${colors.FC2_WHITE};
  border-radius: 2px;
  border: 1px solid ${colors.FC2_LIGHTEST_GREY};
  display: flex;
  height: ${({ $size }) => ($size === 'small' ? '24px' : '27px')};
  justify-content: center;
  width: ${({ $size }) => ($size === 'small' ? '36px' : '40px')};
`
